import { useSelector } from "react-redux";

import { useIntl } from "react-intl";

import { getFilteredSelectedRecordsCount } from "@app/scene/map/store/selectors";

import messages from "./messages";

const useStepTitle = () => {
  const intl = useIntl();
  const leadsCount = useSelector(getFilteredSelectedRecordsCount);

  return intl.formatMessage(messages.title, { count: leadsCount });
};

export default useStepTitle;
